import { render, staticRenderFns } from "./SortableTh.vue?vue&type=template&id=3fd5fa9b&scoped=true"
import script from "./SortableTh.vue?vue&type=script&lang=js"
export * from "./SortableTh.vue?vue&type=script&lang=js"
import style0 from "./SortableTh.vue?vue&type=style&index=0&id=3fd5fa9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd5fa9b",
  null
  
)

export default component.exports